export const userTypeRequestKeys = {
	all: ['userTypeRequests'] as const,
	pending: (userId?: string) => [...userTypeRequestKeys.all, 'pending', userId ?? 'self'] as const,
};
